//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import React, { useState } from "react";
import { createFragmentContainer } from "react-relay";
// microsoft-auth-redirect imports
import { fragments } from "./MicrosoftAuthRedirect.gql";
// util
import { M365_AUTH_COMPLETE_MESSAGE } from "@util/msft-auth.util";
import { m365Nonce } from "@state/local-storage";
import { getServerUrl } from "@clockwise/web-commons/src/util/post-message-common.util";
import { logger } from "@util/logger.util";
// material-ui
import { makeStyles } from "@material-ui/styles";

interface IContainer {
  viewer: ISchema.IViewer;
}

interface IProps extends IContainer {}

const useStyles = makeStyles({
  container: {
    padding: 10,
  },
});

//////////////////
// COMPONENT
//////////////////
const MicrosoftAuthRedirectCmpt = (_props: IProps) => {
  const classes = useStyles();

  const [error, setError] = useState("");

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    // if (searchParams.has("error")) {
    //   setError("Auth error: " + searchParams.get("error"));
    //   return;
    // }

    if (!searchParams.has("code") || !searchParams.has("state")) {
      setError("Something went wrong with your authentication, missing a required field.");
      logger.error("microsoft auth error - missing required fields");

      sendMessageToParentWindow(false);
      return;
    }

    const microsoftAuthCode = searchParams.get("code") as string;
    const state = searchParams.get("state") as string;

    if (!m365Nonce.get() || m365Nonce.get() !== state) {
      setError("Something went wrong with your authentication, state parameter is incorrect.");
      logger.error("microsoft auth error - bad state parameter");

      sendMessageToParentWindow(false);
      return;
    }

    sendMessageToParentWindow(true, microsoftAuthCode);
    window.close();
  }, []);

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  const sendMessageToParentWindow = (success: boolean, authCode?: string) => {
    if (!window.opener) {
      return logger.error("failed to find window.opener for msft auth redirect");
    }

    window.opener.postMessage(
      { message: M365_AUTH_COMPLETE_MESSAGE, success, authCode },
      getServerUrl(),
    );
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  if (error) {
    return (
      <div className={classes.container}>
        There was a problem authenticating. &nbsp;
        {error}
      </div>
    );
  }

  return <div className={classes.container}>verifying...</div>;
};

//////////////////
// RELAY
//////////////////
export const MicrosoftAuthRedirect = createFragmentContainer<IContainer>(
  MicrosoftAuthRedirectCmpt,
  fragments,
);
